import { render } from "./Favorite.vue?vue&type=template&id=30600685&scoped=true"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"

import "./Favorite.vue?vue&type=style&index=0&id=30600685&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30600685"]])

export default __exports__